import "./App.css";

import { useMemo } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { grey } from "@mui/material/colors";
import { Box, CssBaseline, ThemeProvider, createTheme, useMediaQuery } from "@mui/material";

import "./App.css";
import Home from "./components/Home";
import Claim from "./components/auth/Claim";
import Keys from "./components/keys/Keys";
import Users from "./components/users/Users";
import Status from "./components/auth/Status";
import Events from "./components/events/Events";
import Welcome from "./components/auth/Welcome";
import Connect from "./components/orgs/Connect";
import Profile from "./components/users/Profile";
import NotFound from "./components/utils/NotFound";
import Projects from "./components/projects/Projects";
import SignupLocal from "./components/auth/SignupLocal";
import SigninLocal from "./components/auth/SigninLocal";
import AcceptInvite from "./components/auth/AcceptInvitation";
import Organization from "./components/orgs/Organization";
import Organizations from "./components/orgs/Organizations";
import ResetPassword from "./components/auth/ResetPassword";
import RequestDetail from "./components/requests/Detail";
import ForgotPassword from "./components/auth/ForgotPassword";
import RequestsClosed from "./components/requests/Closed";
import RequestsPending from "./components/requests/Pending";

const App = () => {
  const darkMode = useMediaQuery("(prefers-color-scheme: dark)");

  const theme = useMemo(
    () =>
      createTheme({
        components: {
          MuiPaper: {
            styleOverrides: {
              ...(!darkMode && {
                root: {
                  backgroundColor: grey["A100"]
                  // backgroundColor: yellow[200],
                  // backgroundColor: "#08c",
                }
              })
            }
          }
        },
        palette: {
          mode: darkMode ? "dark" : "light",
          primary: {
            main: "#360000ff"
          },
          secondary: {
            // main: "#4B3621",
            main: "#c0182a"
          },
          // primary: grey,
          // secondary: yellow,
          ...(darkMode && {
            background: {
              default: "#291313ff"
              // default: "#2e2202",
              // default: "#080531",
              // paper: "#343541",
            }
          })
        }
      }),
    [darkMode]
  );

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          display: "flex",
          minHeight: "100vh",
          flexDirection: "column"
        }}
      >
        <CssBaseline />

        <Router>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/home" element={<Home />} />
            <Route path="/keys" element={<Keys />} />
            <Route path="/users" element={<Users />} />
            <Route path="/audit" element={<Events />} />
            <Route path="/status" element={<Status />} />
            <Route path="/signup" element={<SignupLocal />} />
            <Route path="/signin" element={<SigninLocal />} />
            <Route path="/welcome" element={<Welcome />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/connect" element={<Connect />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/projects/:id" element={<Keys />} />
            <Route path="/requests/:id" element={<RequestDetail />} />
            <Route path="/organization" element={<Organization />} />
            <Route path="/organizations" element={<Organizations />} />
            <Route path="/requests/closed" element={<RequestsClosed />} />
            <Route path="/requests/pending" element={<RequestsPending />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />

            <Route path="/claim/*" element={<Claim />} />
            <Route path="/accept-invitation/*" element={<AcceptInvite />} />
            <Route path="/*" element={<NotFound />} />
          </Routes>
        </Router>
      </Box>
    </ThemeProvider>
  );
};

export default App;
